import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const DeclineIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g
                id="Icon / Decline"
                fill="none"
                stroke={props.htmlColor ?? '#2196F3'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path
                    id="Vector"
                    d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
                />
                <path id="Vector_2" d="M12.2627 7.73718L7.73721 12.2627" />
                <path id="Vector_3" d="M7.7373 7.73724L12.2628 12.2627" />
            </g>
        </SvgIcon>
    );
};
